module.exports = __webpack_public_path__ + "img/logo-header.c6c4b915.png";